<nav mat-tab-nav-bar [tabPanel]="tabPanel" animationDuration="0" class="workspace-tab-nav">
  @for (tab of tabs(); track tab.objectId) {
    <a
      mat-tab-link
      class="workspace-tab"
      [class.workspace-tab-active]="tab.objectId === activeObjectId()"
      [active]="tab.objectId === activeObjectId()"
      [matTooltip]="tab.name"
      (click)="tabClick.emit(tab.objectId)"
    >
      @if (tab.name) {
        <span class="workspace-tab-name">{{ tab.name }}</span>
      } @else {
        <span class="workspace-tab-skeleton" aria-hidden="true"></span>
      }
      <button
        type="button"
        class="workspace-tab-close"
        [attr.aria-label]="'OBJECT_WORKSPACE.CLOSE_TAB' | translate"
        (click)="$event.stopPropagation(); tabClose.emit(tab.objectId)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </a>
  }
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
